module.exports = __webpack_public_path__ + "images/paper-add.1788773129009.png";